import React from 'react';
import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { Row, Column, IBox, Button } from '../inspinia'
import { templateAction } from '../../store/template';
import TemplateList from '../templateList/index';
import { campanhaAction } from '../../store/campanha';

class Templates extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            pageSize: 10,
            currentPage: 1,
            filter: '',
            list: {
                content: [],
                totalElements: 0,
                size: 10,
                number: 0
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.RecuperarTemplates = this.RecuperarTemplates.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

    }

    formInitialState() {
        return {
            id: "",
            template: [],
            nomeTemplateHtml: "",
            file: ""
        }
    }

    componentDidMount() {
        this.RecuperarTemplates();
    }

    RecuperarTemplates(page = 1, filter = '') {
        const { pageSize, optionsGet } = this.state;

        const hasFilter = filter && filter.trim().length > 0;

        const url = hasFilter
            ? `${c.API_CAMPAIGN_URL}/template-filtrado/${encodeURIComponent(filter)}` +
            `?page=${page - 1}&size=${pageSize}`

            : `${c.API_CAMPAIGN_URL}/template-name` +
            `?page=${page - 1}&size=${pageSize}`;
            
        callApi(url, optionsGet, (response) => {
            this.setState({
                list: response,
                currentPage: response.number + 1,
                loading: false
            });
        });
    }

    handlePageChange(pageNumber) {
        this.RecuperarTemplates(pageNumber, this.state.filter);
    }

    handleSearch(filterValue) {
        const q = (filterValue ?? '').trim();

        if (q === '') {
            this.setState({ filter: '' }, () => {
                this.RecuperarTemplates(1, ''); 
            });
        } else {
            this.setState({ filter: q }, () => {
                this.RecuperarTemplates(1, q);
            });
        }
    }

    render() {
        const form = this.state.form;

        return (
            <div>
                {/* {Lista de templates} */}
                    <Row className="mb-3">
                        <Column size="12">
                        <TemplateList
                            status={this.state}
                            onReloadTemplates={this.RecuperarTemplates}
                            templates={this.state.list.content}
                            history={this.props.history}
                            recarregar={true}
                            totalElements={this.state.list.totalElements}
                            pageSize={this.state.list.size}
                            currentPage={this.state.currentPage}
                            filter={this.state.filter}
                            onSearch={this.handleSearch}
                            onPageChange={this.handlePageChange}
                            customEditAction={(id) => this.props.history.push(`templates/editar-template/${id}`)}
                            customNewAction={() => this.props.history.push('templates/editar-template')}
                        />
                        </Column>
                    </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, template: state.template, arquivo: state.campanha };
}

function mapDispatchToProps(dispatch) {
    return { actions: { template: bindActionCreators(templateAction, dispatch), arquivo: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Templates));
